import { useMutation, UseMutationOptions } from 'react-query';
import { getCEP, getCNPJ } from './api.ts';
import { ICEPResponse, ICNPJResponse } from './types.ts';

export function useGetCNPJMutation(options: UseMutationOptions<ICNPJResponse | undefined, unknown, string, unknown>) {
  return useMutation((cnpj: string) => getCNPJ(cnpj), options);
}

export function useGetCEPMutation(options: UseMutationOptions<ICEPResponse | undefined, unknown, string, unknown>) {
  return useMutation((cep: string) => getCEP(cep), options);
}
